import { createSlice } from "@reduxjs/toolkit";
import { Option } from "../../common/types/Types";
import { EmployeeScheduledQualificationInterface } from "../../common/interfaces/ScheduledQualificationInterface";

const formValuesEmptyState = {
    employee: { value: "", label: "" },
    educator: { value: "", label: "" },
    qualification: { value: "", label: "" },
    startDate: "",
    endDate: "",
};

export interface UpsertScheduleQualificationModalInterface {
    isScheduleQualificationModalOpen: boolean;
    isPatchCreateScheduledQualificationSuccess: boolean;
    isPatchEditScheduledQualificationSuccess?: boolean;
    employeeScheduledQualification?: EmployeeScheduledQualificationInterface;
    formValues?: {
        employeeScheduledQualificationId?: string;
        employee: Option;
        educator: Option;
        qualification: Option;
        startDate: string;
        endDate: string;
    };
    error?: string;
}

const initialState: UpsertScheduleQualificationModalInterface = {
    isScheduleQualificationModalOpen: false,
    isPatchCreateScheduledQualificationSuccess: false,
    isPatchEditScheduledQualificationSuccess: false,
    formValues: formValuesEmptyState,
};

const UpsertScheduleQualificationModalSlice = createSlice({
    name: "upsertScheduleQualificationModal",
    initialState,
    reducers: {
        setIsScheduleQualificationModalOpen: (state, action) => {
            state.isScheduleQualificationModalOpen = action.payload;
        },
        setIsPatchCreateScheduledQualificationSuccess: (state, action) => {
            state.isPatchCreateScheduledQualificationSuccess = action.payload;
        },
        setIsPatchEditScheduledQualificationSuccess: (state, action) => {
            state.isPatchEditScheduledQualificationSuccess = action.payload;
        },
        setEmployeeScheduledQualification: (state, action) => {
            state.employeeScheduledQualification = action.payload;
        },
        setFormValues: (state, action) => {
            state.formValues = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        resetFormValues: (state) => {
            state.formValues = formValuesEmptyState;
            state.error = undefined;
            state.employeeScheduledQualification = undefined;
        },
    },
});

export const upsertScheduleQualificationModalReducer =
    UpsertScheduleQualificationModalSlice.reducer;

export const {
    setIsScheduleQualificationModalOpen,
    setIsPatchCreateScheduledQualificationSuccess,
    setIsPatchEditScheduledQualificationSuccess,
    setEmployeeScheduledQualification,
    setFormValues,
    setError,
    resetFormValues,
} = UpsertScheduleQualificationModalSlice.actions;
